import { Flex, Icon, IconName, Link, useModal, withModalConditionalRender } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../enums/modalId'
import { useAcceptAllMatchSuggestions } from './contexts/acceptAllMatchSuggestionsContext'
import { AcceptAllMatchSuggestionsConfirmationModal } from './elements/AcceptAllMatchSuggestionsConfirmationModal'
import * as Styled from './styles'

const AcceptAllMatchSuggestionsModal = withModalConditionalRender(AcceptAllMatchSuggestionsConfirmationModal)

export const AcceptAllMatchSuggestions = (): ReactElement | null => {
  const { t } = useTranslation()
  const { open: openAcceptAllMatchSuggestionsModal } = useModal(ModalId.AcceptAllMatchSuggestionsModal)
  const { matchSuggestionsLoaded, totalMatchSuggestions } = useAcceptAllMatchSuggestions()

  const isLinkDisabled = !matchSuggestionsLoaded || totalMatchSuggestions === 0

  const { buttonText, iconName } = useMemo(() => {
    if (!matchSuggestionsLoaded) {
      return {
        buttonText: t('bank_integration.accept_matches.cta.loading'),
        iconName: 'circleDashed' as IconName,
      }
    }

    return {
      buttonText: t('bank_integration.accept_matches.cta.accept', { total: totalMatchSuggestions }),
      iconName: 'listChecks' as IconName,
    }
  }, [matchSuggestionsLoaded, t, totalMatchSuggestions])

  const handleAcceptSuggestionsClick = useCallback(() => {
    openAcceptAllMatchSuggestionsModal()
  }, [openAcceptAllMatchSuggestionsModal])

  return (
    <>
      <Link underlined={false} onClick={handleAcceptSuggestionsClick} disabled={isLinkDisabled}>
        <Flex>
          <Styled.IconWrapper $loading={!matchSuggestionsLoaded}>
            <Icon icon={iconName} />
          </Styled.IconWrapper>
          {buttonText}
        </Flex>
      </Link>
      <AcceptAllMatchSuggestionsModal id={ModalId.AcceptAllMatchSuggestionsModal} />
    </>
  )
}
